/**
 * Which props each offer tab needs from the server.
 *
 * The controller marks these as optional, so they arrive only when a request
 * names them. Show.tsx uses this to fetch a tab on first click, and each tab's
 * pager uses it so changing page reloads that tab alone.
 *
 * Keep in step with the tab_prop(...) calls in OffersController#show -- a name
 * that does not match a prop there means the tab waits forever for data.
 */
export const OFFER_TAB_PROPS: Record<string, string[]> = {
  basic_info: [],
  creatives: ["templates", "template_folders"],
  subject_lines: [
    "subject_lines",
    "subject_lines_pagination",
    "all_subject_line_descriptions",
  ],
  from_lines: ["from_lines", "from_lines_pagination", "all_from_line_descriptions"],
  footer: ["footers", "footers_pagination"],
  tracking_links: ["tracking_links", "tracking_links_pagination"],
  unsubscribe_links: ["unsubscribe_links", "unsubscribe_links_pagination"],
  discussions: ["discussions"],
};
